module.exports = __webpack_public_path__ + "5d1577422347ad2f2c9ad2944f63a194.png";